import { lazy } from 'react';

export const siteComponents: any = {
 LegalNoticeFirstSection: lazy(() => import("@/predefined-section/legal-notice/first-section/LegalNoticeFirstSection")),
  LegalNoticeCookiesFirstSection: lazy(() => import("@/predefined-section/legal-notice-cookies/first-section/LegalNoticeCookiesFirstSection")),
  // Common components
  Card: lazy(() => import("@/common/components/card/Card")),
  Div: lazy(() => import("@/admin/mock-data/mock-components/Card/Div")),
  Grid: lazy(() => import("@/common/components/grid/Grid")),
  ScrollComponent: lazy(() => import("@/common/components/scrollComponent/ScrollComponent")),
  Section: lazy(() => import("@/common/components/Section/Section")),
  Icon: lazy(() => import("@/common/components/icon/Icon")),
  Button: lazy(() => import("@/common/components/button/Button")),
  Widget: lazy(() => import("@/common/components/widget/Widget")),
  HeroSection: lazy(() => import("@/predefined-section/home/hero-section/HeroSection")),
  AboutSection: lazy(() => import("@/predefined-section/home/about-section/AboutSection")),
  HistorySection: lazy(() => import("@/predefined-section/home/history-section/HistorySection")),
  WineListSection: lazy(() => import("@/predefined-section/home/wine-list-section/WineListSection")),
  WinemakerSection: lazy(() => import("@/predefined-section/home/winemaker-section/WinemakerSection")),
  LocationSection: lazy(() => import("@/predefined-section/home/location-section/LocationSection")),
  NewsSection: lazy(() => import("@/predefined-section/home/news-section/NewsSection")),
  ContactSection: lazy(() => import("@/predefined-section/home/contact-section/ContactSection")),
};
